import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { GetGlobalCurrencies } from '@/connection/integrations/stripe';

export const fetchGlobalCurrencies = (create: ReducerCreators<AudiencesState>) =>
  create.asyncThunk(
    async () => {
      return await GetGlobalCurrencies();
    },
    {
      fulfilled: (state, action) => {
        state.globalCurrencies = action.payload;
      },
    }
  );
